<template>
  <svg class="stroke-current w-8 h-8 mr-1 md:mr-3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 37.63 52.56"><g fill="none"><path d="M22.63 29V5.18a4.68 4.68 0 0 0-9.36 0v42.21a4.66 4.66 0 0 0 4.65 4.67 4.67 4.67 0 0 0 4.66-4.67V31.88"/><path d="M18 49.9a2.85 2.85 0 0 0 2.83-2.84v-2.88m-.77-17.24v-1.29a2.09 2.09 0 0 0-4.18 0v6.26h4.18M13.31 14.8l9.32 7.13v-2.84L13.31 12zm0-5.28l9.32 7.14v-2.84l-9.32-7.14zm-8.15-9a4.66 4.66 0 0 1 4.66 4.66v42.19A4.66 4.66 0 0 1 5.16 52 4.66 4.66 0 0 1 .5 47.37V5.18A4.66 4.66 0 0 1 5.16.52z"/><path d="M5.16 23.54a2.1 2.1 0 0 1 2.11 2.07v6.26h-4.2v-6.25a2.09 2.09 0 0 1 2.09-2.08zm4.66-8.77L.5 21.9v-2.84l9.32-7.13zm0-5.27L.5 16.63v-2.84l9.32-7.13zM5.16 49.87A2.83 2.83 0 0 0 8 47v-2.89m19.55-24.66L37.13 29H18l9.58-9.57V.55M18 29h19.13v2.9H18z"/></g></svg>
</template>

<script>
export default {

};
</script>

<style>

</style>
